import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import OrdersTable from '../components/tables/orders-table';
import YassocialServicesTable from '../components/tables/yassicial-services-table';

const YassocialServicesListRoute: FC = () => {
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="یاس سوشیال"
      style={{ padding: " 16px 0" }}
      onBack={() => navigate(-1)}
    />
    <YassocialServicesTable />
  </>);
}

export default YassocialServicesListRoute;
